import type { OwnerFilter, Payee, Transaction } from "../types";
import type { ReportingScope } from "../types/reporting";
import { isEarnable, isSpendable } from "./finance";

export const merchantKey = (title: string): string => title.trim().toLocaleLowerCase();

/** Linked Payee, transaction-only payee draft, then title for merchant reporting. */
export function merchantLabel(entry: Transaction, payees?: Payee[]): string {
  if (entry.payeeId && payees?.length) {
    const found = payees.find((p) => p.id === entry.payeeId);
    if (found?.name.trim()) return found.name.trim();
  }
  return entry.draftPayeeName?.trim() || entry.title.trim();
}

/** Shared eligibility for Insights and its History drill-downs. */
export function matchesReportingScope(entry: Transaction, today: string, scope: ReportingScope, payees?: Payee[]): boolean {
  return !entry.pendingKey && entry.date.slice(0, 10) <= today &&
    (isSpendable(entry) || isEarnable(entry)) &&
    (scope.activity === "all" || (scope.activity === "trips" ? !!entry.tripId : !entry.tripId)) &&
    (scope.merchant === undefined || (isSpendable(entry) && entry.reportableAmount > 0 && (
      merchantKey(merchantLabel(entry, payees)) === scope.merchant ||
      merchantKey(entry.title) === scope.merchant
    )));
}

export function readReportingScope(params: URLSearchParams): ReportingScope | null {
  const activity = params.get("report");
  if (activity !== "all" && activity !== "everyday" && activity !== "trips") return null;
  return { activity, ...(params.has("merchant") ? { merchant: params.get("merchant") ?? "" } : {}) };
}

/** Report links retain their chosen owner even when the signed-in profile differs. */
export function readReportingOwner(params: URLSearchParams, fallback: OwnerFilter): OwnerFilter {
  return readReportingScope(params) ? params.get("reportOwner") || fallback : fallback;
}
